class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        const _pInput_max = document.getElementById("Filter-Price-LTE");
        const _pInput_min = document.getElementById("Filter-Price-GTE");

        this.debouncedOnSubmit = debounce((event) => {
            console.log("which->", event);
            const _input_id = event.target.id;
            if (_input_id == "r_c_1") {
                _pInput_max.value = 2000;
                _pInput_min.value = "";
            }
            if (_input_id == "r_c_2") {
                _pInput_max.value = 6000;
                _pInput_min.value = 2000;
            }
            if (_input_id == "r_c_3") {
                _pInput_max.value = 10000;
                _pInput_min.value = 6000;
            }
            if (_input_id == "r_c_4") {
                _pInput_min.value = 10000;
                _pInput_max.value = "";
            }
            this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector("form");
        facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
        if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

        // this.initFilterChecked()

    }

    initFilterChecked() {
        console.log("ttttt")
        let _ls_ec_filter_size = localStorage.getItem("ec_filter_size");
        const _ec_filter_size = document.querySelectorAll(
            'input[name="ec_filter_size"]'
        );
        for (const chk of _ec_filter_size) {
            if (_ls_ec_filter_size) {
                if (_ls_ec_filter_size.includes(chk.value)) {
                    chk.checked = true;
                }
            }
        }
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state
                ? event.state.searchParams
                : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener("popstate", onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
            element.classList.toggle("disabled", disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById("ProductCount");
        const countContainerDesktop = document.getElementById(
            "ProductCountDesktop"
        );
        document
            .getElementById("ProductGridContainer")
            .querySelector(".collection")
            .classList.add("loading");
        if (countContainer) {
            countContainer.classList.add("loading");
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add("loading");
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) {
            console.log("ffff");
            var elem = document.getElementById("product-grid");
            var msnry = new Masonry(elem, {
                // options
                gutter: 60,
                itemSelector: ".ecc_grid__item",
            });
            FacetFiltersForm.updateURLHash(searchParams);
            // goResetOrderListing()
            setTimeout(get_customer_favorites, 1000);
        }
    }

    static renderSectionFromFetch(url, event) {
        console.log(url);
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                // console.log(html);
                FacetFiltersForm.filterData = [
                    ...FacetFiltersForm.filterData,
                    { html, url },
                ];
                // FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
                resetFavorites();
                var elem = document.getElementById("product-grid");
                var msnry = new Masonry(elem, {
                    // options
                    gutter: 60,
                    itemSelector: ".ecc_grid__item",
                });
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        // FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById("ProductGridContainer").innerHTML;
    }

    static renderProductCount(html) {
        const count = new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById("ProductCount").innerHTML;
        const container = document.getElementById("ProductCount");
        const containerDesktop = document.getElementById("ProductCountDesktop");
        container.innerHTML = count;
        container.classList.remove("loading");
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove("loading");
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");

        const facetDetailsElements = parsedHTML.querySelectorAll(
            "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
        );
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest(".js-filter") : undefined;
            return jsFilter
                ? element.dataset.index === jsFilter.dataset.index
                : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter(
            (element) => !matchesIndex(element)
        );
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            document.querySelector(
                `.js-filter[data-index="${element.dataset.index}"]`
            ).innerHTML = element.innerHTML;
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender)
            FacetFiltersForm.renderCounts(
                countsToRender,
                event.target.closest(".js-filter")
            );
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = [
            ".active-facets-mobile",
            ".active-facets-desktop",
        ];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML =
                activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = [
            ".mobile-facets__open",
            ".mobile-facets__count",
            ".sorting",
        ];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML =
                html.querySelector(selector).innerHTML;
        });

        document
            .getElementById("FacetFiltersFormMobile")
            .closest("menu-drawer")
            .bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector(".facets__selected");
        const sourceElement = source.querySelector(".facets__selected");

        const targetElementAccessibility = target.querySelector(".facets__summary");
        const sourceElementAccessibility = source.querySelector(".facets__summary");

        if (sourceElement && targetElement) {
            target.querySelector(".facets__selected").outerHTML =
                source.querySelector(".facets__selected").outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector(".facets__summary").outerHTML =
                source.querySelector(".facets__summary").outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState(
            { searchParams },
            "",
            `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
        );
    }

    static getSections() {
        return [
            {
                section: document.getElementById("product-grid").dataset.id,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        console.log("-formData:", formData);
        const _zx_filter_section = document.querySelector('.zx-fitler-resultr-list');
        let _is_show_zfrl = false;
        //price
        const _zx_filter_price = document.querySelector('.zfrl-price');
        let _is_show_price = false;
        if (formData.has("r_p_c")) {
            _is_show_zfrl = true;
            _is_show_price = true
            const _p_start = document.querySelector('.p_start');
            const _p_end = document.querySelector('.p_end');
            if (formData.get("r_p_c") == "fpr1") {
                formData.set("filter.v.price.gte", 0);
                formData.set("filter.v.price.lte", 2000);
                _p_start.innerText = "$0";
                _p_end.innerText = "$2000";
            }
            if (formData.get("r_p_c") == "fpr2") {
                formData.set("filter.v.price.gte", 2000);
                formData.set("filter.v.price.lte", 6000);
                _p_start.innerText = "$2000";
                _p_end.innerText = "$6000";
            }
            if (formData.get("r_p_c") == "fpr3") {
                formData.set("filter.v.price.gte", 6000);
                formData.set("filter.v.price.lte", 10000);
                _p_start.innerText = "$6000";
                _p_end.innerText = "$10000";
            }
            if (formData.get("r_p_c") == "fpr4") {
                formData.set("filter.v.price.gte", 10000);
                formData.set("filter.v.price.lte", "");
                _p_start.innerText = "$10000";
                _p_end.innerText = "";
            }
            if (formData.get("r_p_c") == "fpr5") {
                formData.set("filter.v.price.gte", "");
                formData.set("filter.v.price.lte", "");
                _p_start.innerText = "";
                _p_end.innerText = "";
                _is_show_price = false;
                _is_show_zfrl = false;
            }
        }
        const _serch_p = new URLSearchParams(formData);
        const _o_checkbox_color = document.querySelectorAll(
            ".ec-match-checkbox-cus_color"
        );
        const _o_checkbox_genres = document.querySelectorAll(
            ".ec-match-checkbox-cus_genres"
        );
        const _o_checkbox_medium = document.querySelectorAll(
            ".ec-match-checkbox-cus_medium"
        );
        const _o_checkbox_size = document.querySelectorAll(
            ".ec-match-checkbox-cus_longest_side"
        );
        //set filter result list
        //medium
        const _zx_filter_medium = document.querySelector('.zfrl-medium');
        const _medium_list = _zx_filter_medium.querySelectorAll('li');
        for (const _item of _medium_list) {
            _item.style.display = "none";
        }
        let _is_show_medium = false;
        //genres
        const _zx_filter_genres = document.querySelector('.zfrl-genres');
        const _genres_list = _zx_filter_genres.querySelectorAll('li');
        for (const _item of _genres_list) {
            _item.style.display = "none";
        }
        let _is_show_genres = false;
        //color
        const _zx_filter_color = document.querySelector('.zfrl-color');
        const _color_list = _zx_filter_color.querySelectorAll('li');
        for (const _item of _color_list) {
            _item.style.display = "none";
        }
        let _is_show_color = false;
        //size
        const _zx_filter_size = document.querySelector('.zfrl-size');
        const _size_list = _zx_filter_size.querySelectorAll('li');
        for (const _item of _size_list) {
            _item.style.display = "none";
        }
        let _is_show_size = false;
        _serch_p.forEach((value, key) => {
            if (key == "ec_filter_color") {
                _is_show_zfrl = true;
                _is_show_color = true;
                const checkboxes = document.querySelectorAll('input[name="ec_filter_color"]:checked');
                const selectedValues = [];
                checkboxes.forEach(checkbox => {
                    selectedValues.push(checkbox.value.toLowerCase());
                });
                for (const _item of _color_list) {
                    if (selectedValues.includes(_item.getAttribute('data-label').toLowerCase())) {
                        _item.style.display = "flex";
                    }
                }
                console.log(selectedValues)
                for (const _oc of _o_checkbox_color) {
                    _oc.checked = false;
                    const _o_value = _oc.value.toLowerCase();
                    if (_o_value.indexOf(value.toLowerCase()) >= 0) {
                        //check is exit
                        let _isHave = false;
                        _serch_p.forEach((value_, key_) => {
                            if (
                                key_ == "filter.p.m.wk_custom_field.cus_color" &&
                                value_ == _oc.value
                            ) {
                                _isHave = true;
                            }
                        });
                        if (!_isHave) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_color",
                                _oc.value
                            );
                        }
                    }
                }
            }
            if (key == "ec_filter_genres") {
                _is_show_zfrl = true;
                _is_show_genres = true;
                const checkboxes = document.querySelectorAll('input[name="ec_filter_genres"]:checked');
                const selectedValues = [];
                checkboxes.forEach(checkbox => {
                    selectedValues.push(checkbox.value.toLowerCase());
                });
                for (const _item of _genres_list) {
                    if (selectedValues.includes(_item.getAttribute('data-label').toLowerCase())) {
                        _item.style.display = "flex";
                    }
                }
                console.log(selectedValues)
                for (const _oc of _o_checkbox_genres) {
                    _oc.checked = false;
                    const _o_value = _oc.value.toLowerCase();
                    if (_o_value.indexOf(value.toLowerCase()) >= 0) {
                        //check is exit
                        let _isHave = false;
                        _serch_p.forEach((value_, key_) => {
                            if (
                                key_ == "filter.p.m.wk_custom_field.cus_genres" &&
                                value_ == _oc.value
                            ) {
                                _isHave = true;
                            }
                        });
                        if (!_isHave) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_genres",
                                _oc.value
                            );
                        }
                    }
                }
            }
            if (key == "ec_filter_medium") {
                _is_show_zfrl = true;
                _is_show_medium = true;
                const checkboxes = document.querySelectorAll('input[name="ec_filter_medium"]:checked');
                const selectedValues = [];
                checkboxes.forEach(checkbox => {
                    selectedValues.push(checkbox.value.toLowerCase());
                });
                for (const _item of _medium_list) {
                    if (selectedValues.includes(_item.getAttribute('data-label').toLowerCase())) {
                        _item.style.display = "flex";
                    }
                }
                console.log(selectedValues)
                for (const _oc of _o_checkbox_medium) {
                    _oc.checked = false;
                    const _o_value = _oc.value.toLowerCase();
                    if (_o_value.indexOf(value.toLowerCase()) >= 0) {
                        //check is exit
                        let _isHave = false;
                        _serch_p.forEach((value_, key_) => {
                            if (
                                key_ == "filter.p.m.wk_custom_field.cus_medium" &&
                                value_ == _oc.value
                            ) {
                                _isHave = true;
                            }
                        });
                        if (!_isHave) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_medium",
                                _oc.value
                            );
                        }
                    }
                }
            }
            if (key == "ec_filter_size") {
                _is_show_zfrl = true;
                _is_show_size = true;
                const checkboxes = document.querySelectorAll('input[name="ec_filter_size"]:checked');
                const selectedValues = [];
                checkboxes.forEach(checkbox => {
                    selectedValues.push(checkbox.value.toLowerCase());
                });
                for (const _item of _size_list) {
                    if (selectedValues.includes(_item.getAttribute('data-label').toLowerCase())) {
                        _item.style.display = "flex";
                    }
                }
                console.log(selectedValues)
                for (const _oc of _o_checkbox_size) {
                    _oc.checked = false;
                    const _o_value = parseInt(_oc.value);
                    if (value == "0-60") {
                        if (_o_value > 0 && _o_value <= 60) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_longest_side",
                                _oc.value
                            );
                        }
                    }
                    if (value == "60-100") {
                        if (_o_value > 60 && _o_value <= 100) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_longest_side",
                                _oc.value
                            );
                        }
                    }
                    if (value == "100-200") {
                        if (_o_value > 100 && _o_value <= 200) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_longest_side",
                                _oc.value
                            );
                        }
                    }
                    if (value == "200") {
                        if (_o_value > 200) {
                            _serch_p.append(
                                "filter.p.m.wk_custom_field.cus_longest_side",
                                _oc.value
                            );
                        }
                    }
                }
            }
        });
        if (_is_show_zfrl) {
            _zx_filter_section.style.display = "flex";
        } else {
            _zx_filter_section.style.display = "none";
        }
        if (_is_show_price) {
            _zx_filter_price.style.display = "flex";
        } else {
            _zx_filter_price.style.display = "none";
        }
        if (_is_show_medium) {
            _zx_filter_medium.style.display = "flex";
        } else {
            _zx_filter_medium.style.display = "none";
        }
        if (_is_show_genres) {
            _zx_filter_genres.style.display = "flex";
        } else {
            _zx_filter_genres.style.display = "none";
        }
        if (_is_show_color) {
            _zx_filter_color.style.display = "flex";
        } else {
            _zx_filter_color.style.display = "none";
        }
        if (_is_show_size) {
            _zx_filter_size.style.display = "flex";
        } else {
            _zx_filter_size.style.display = "none";
        }
        _serch_p.delete("ec_filter_color");
        _serch_p.delete("ec_filter_genres");
        _serch_p.delete("ec_filter_medium");
        _serch_p.delete("ec_filter_size");
        return _serch_p.toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll(
            "facet-filters-form form"
        );
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(
                event.target.closest("form")
            );
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile =
                event.target.closest("form").id === "FacetFiltersFormMobile";

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (
                        form.id === "FacetSortForm" ||
                        form.id === "FacetFiltersForm" ||
                        form.id === "FacetSortDrawerForm"
                    ) {
                        const noJsElements = document.querySelectorAll(".no-js-list");
                        noJsElements.forEach((el) => el.remove());
                        console.log("pushDta->", this.createSearchParams(form));
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === "FacetFiltersFormMobile") {
                    console.log("pushDta->", this.createSearchParams(form));
                    forms.push(this.createSearchParams(form));
                }
            });
            console.log("-form->", forms);
            this.onSubmitForm(forms.join("&"), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf("?") == -1
                ? ""
                : event.currentTarget.href.slice(
                    event.currentTarget.href.indexOf("?") + 1
                );
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll("input").forEach((element) =>
            element.addEventListener("change", this.onRangeChange.bind(this))
        );
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute("max", maxInput.value);
        if (minInput.value) maxInput.setAttribute("min", minInput.value);
        if (minInput.value === "") maxInput.setAttribute("min", 0);
        if (maxInput.value === "")
            minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute("min"));
        const max = Number(input.getAttribute("max"));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button");
        facetLink.addEventListener("click", this.closeFilter.bind(this));
        facetLink.addEventListener("keyup", (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form =
            this.closest("facet-filters-form") ||
            document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
    }
}

customElements.define("facet-remove", FacetRemove);

document.addEventListener('DOMContentLoaded', function () {
    initFilterResult();
    const remove_zfrl = document.querySelectorAll(".zftl-block svg");
    remove_zfrl.forEach(svg => {
        svg.addEventListener('click', function () {
            const _value = svg.getAttribute("data-value")
            console.log('SVG element clicked:', _value);
            if (_value == "price") {
                const price_move = document.getElementById("r_c_5")
                price_move.click();
            } else {
                const checkbox = document.getElementById(`ec_filter_${_value}`);
                checkbox.click();
            }
        });

    });
})

const initFilterResult = () => {
    console.log("start init filter result")
    const url_p_list = getCurrentUrlParams();
    const _zx_filter_section = document.querySelector('.zx-fitler-resultr-list');
    let _is_show_zfrl = false;
    const urlParams = new URLSearchParams(window.location.search);
    //medium
    const q_medium_v = urlParams.get("filter.p.m.wk_custom_field.cus_medium");
    const _zx_filter_medium = document.querySelector('.zfrl-medium');
    const _medium_list = _zx_filter_medium.querySelectorAll('li');
    if (q_medium_v) {
        _is_show_zfrl = true;
        const checkboxes = document.querySelectorAll('input[name="ec_filter_medium"]');
        for (const _chk of checkboxes) {
            console.log("==PP", _chk.value.toLocaleLowerCase())
            if (containsFilterValue(url_p_list, "medium", _chk.value.toLocaleLowerCase())) {
                _chk.checked = true;
            }
        }
        for (const _item of _medium_list) {
            console.log(_item.getAttribute('data-label'))
            if (containsFilterValue(url_p_list, "medium", _item.getAttribute('data-label').toLocaleLowerCase())) {
                console.log('----> yes')
                _item.style.display = "flex";
            }
        }
        _zx_filter_medium.style.display = "flex";
    }
    //color
    const q_color_v = urlParams.get("filter.p.m.wk_custom_field.cus_color");
    const _zx_filter_color = document.querySelector('.zfrl-color');
    const _color_list = _zx_filter_color.querySelectorAll('li');
    if (q_color_v) {
        _is_show_zfrl = true;
        const checkboxes = document.querySelectorAll('input[name="ec_filter_color"]');
        for (const _chk of checkboxes) {
            console.log("==PP", _chk.value.toLocaleLowerCase())
            if (containsFilterValue(url_p_list, "color", _chk.value.toLocaleLowerCase())) {
                _chk.checked = true;
            }
        }
        for (const _item of _color_list) {
            console.log(_item.getAttribute('data-label'))
            if (containsFilterValue(url_p_list, "color", _item.getAttribute('data-label').toLocaleLowerCase())) {
                console.log('----> yes')
                _item.style.display = "flex";
            }
        }
        _zx_filter_color.style.display = "flex";
    }
    if (_is_show_zfrl) {
        _zx_filter_section.style.display = "flex";
    } else {
        _zx_filter_section.style.display = "none";
    }
}

function containsFilterValue(data, flag, color) {
    const colorToCheck = color.toLowerCase();
    let array = [];
    if (flag == "medium") {
        array = data["filter.p.m.wk_custom_field.cus_medium"];
    }
    if (flag == "genres") {
        rray = data["filter.p.m.wk_custom_field.cus_genres"];
    }
    if (flag == "color") {
        array = data["filter.p.m.wk_custom_field.cus_color"];
    }
    if (flag == "size") {
        array = data["filter.p.m.wk_custom_field.cus_size"];
    }

    return array.some(item =>
        item.toLowerCase().split(", ").includes(colorToCheck)
    );
}

const getCurrentUrlParams = () => {
    const url = window.location.href;
    const params = {};
    const urlObj = new URL(url);
    const queryString = urlObj.search;
    const urlSearchParams = new URLSearchParams(queryString);
    for (const [key, value] of urlSearchParams.entries()) {
        if (params.hasOwnProperty(key)) {
            params[key].push(value);
        } else {
            params[key] = [value];
        }
    }

    return params;
}